// extracted by mini-css-extract-plugin
module.exports = {"total":"ValidatorActions_total__4cA1y"};